export enum Decorator {
    Sorting = 'sorting',
}

export enum Filter {
    ConstructionType = 'construction_type',
    EnergyLabel = 'energy_label',
    FixedPeriod = 'fixed_period',
    FixedPeriods = 'fixed_periods',
    Label = 'label',
    Labels = 'labels',
    LoanForm = 'loan_form',
    ModificationLoanForm = 'modification_loan_form',
    ModificationLoanFormName = 'modification_loan_form_name',
    NewsLabels = 'news_labels',
    NHG = 'nhg',
    MortgageProperties = 'mortgage_properties',
    RiskCategory = 'risk_category',
    DateFrom = 'date_from',
    DateTo = 'date_to',
    ClientType = 'client_type',
    BridgingLoanLabels = 'bridging_loan_labels',
    Account = 'account',
}
